import { makeStyles } from '@material-ui/core';
import React from 'react';
import NoiseBackground from '../../../public/noise-256.png';

export interface BackgroundProps {
  children: any;
}

export default function Background({ children }: BackgroundProps) {
  //Need to replace the BUILD_ID in the bundled url with the actual buildId
  const noiseBackgroundUrl = NoiseBackground.replace(
    'BUILD_ID',
    window.buildId,
  );

  //Needed to put makeStyles in the render function
  const classes = makeStyles((theme) => ({
    root: {
      backgroundColor: theme.palette.common.white,
      height: '100vh',
      backgroundSize: '300% 300%',
      backgroundImage: `linear-gradient(-35deg,
          #03142d 0%,
          #043042 50%,
          #031329 100%
        )`,
      overflow: 'hidden',
      position: 'relative',
    },
    spark1: {
      backgroundColor: '#64FFDA',
      position: 'absolute',
      width: '50%',
      height: '50%',
      filter: 'blur(300px)',
      transformOrigin: '10% -10%',
      left: '0%',
      top: '90%',
      borderRadius: '50%',
      opacity: 0.5,
    },
    spark2: {
      backgroundColor: '#64FFDA',
      position: 'absolute',
      width: '50%',
      height: '50%',
      filter: 'blur(300px)',
      transformOrigin: '90% 90%',
      left: '45%',
      top: '15%',
      borderRadius: '50%',
      opacity: 0.5,
    },
    noise: {
      position: 'absolute',
      top: 0,
      left: 0,
      height: '100%',
      width: '100%',
      backgroundImage: `url(${noiseBackgroundUrl})`,
      backgroundRepeat: 'repeat',
    },
  }))();

  return (
    <div className={classes.root}>
      <div className={classes.spark1} />
      <div className={classes.spark2} />
      <div className={classes.noise} />
      {children}
    </div>
  );
}
